import React, { useEffect, useState, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import {axiosWithAuth} from "./axiosWithAuth";
import axios from 'axios'

const initial = {
    event_name: '',
    date: '',
    time:'',
    description: '',
    organizer_id: localStorage.getItem(' organizer_id')
}

const EventEdit = () => {
    const history = useHistory()
    const [form, setForm] = useState(initial)
    const {id} = useParams(/*'/events/:id'*/)

    const cancel = () => {
        setForm(initial)
        history.push('/home')
    }

    // const getEvent = (id) => {
    //     axiosWithAuth()
    //         .get(`/events/${form.id}`)
    //         .then((res) => {
    //             setForm(res.data)
    //             console.log(res)
    //         })
    //         .catch((error) => {
    //             console.log(error)
    //         })
    //     }

    useEffect(()=>{
        axiosWithAuth()
        .get(`events/${id}`)
        .then(res => {
            setForm(res.data.event)
            console.log(res)
        })
        .catch(error => {
            console.log(error)
        })
    },[id])

    const handleC = (event) => {
        event.preventDefault()
        const {name, value} = event.target
        setForm({
            ...form, 
            [name]:value})
    }

    const submit = () => {
        axiosWithAuth()
        .put(`/events/${id}`, form)
        .then(res => {
            console.log(res)

        })
        .catch((error) => {
            console.log(error)
        })
        history.push('/home')
    }

    return (
        <div>
            <form onSubmit={() => submit(id)}>
                <label>Event:
                <input type="text" name="event_name" value={form.event_name} onChange={handleC}/>
                </label>
                <label > Date:
                <input type="text" name="date" value={form.date} onChange={handleC}/>
                </label>
                <label> Time:
                <input type="text" name="time" value={form.time} onChange={handleC}/>
                </label>
                <label> Description:
                <input type="text" name="description" value={form.description} onChange={handleC}/>
                </label>
                <label>
                <button className="cardBtn">Post!</button>
                <button onClick = {cancel}></button>
            </label>

            </form>
        </div>   
    )
}

export default EventEdit